import React from 'react';
import PropTypes from 'prop-types';
import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';
import styles, { mainCls, clsCtr, clsInput } from './styles';
import Grid from '../Grid';
import GridItem from '../GridItem';

const useStyles = createStyle(styles);

export default function RadioField({
  className,
  radioClassName,
  name,
  value,
  label,
  color,
  onChange,
  checked,
  disabled,
  align,
  noGutters,
  children,
  noWrap,
}) {
  const classes = useStyles();
  const handleChange = () => onChange(value);
  const clsStr = makeClassName([
    classes[mainCls],
    className,
    'is-clickable',
    noWrap && 'tp--ell',
  ]);
  const clsCtrStr = makeClassName([
    classes[clsCtr],
    radioClassName,
    checked && `c-bg--${color}`,
    'b-r--100',
  ]);
  const labelRes = label || children;
  const labelCLs = makeClassName([
    `${mainCls}__grid-label`,
    'pl--s',
    noWrap && 'tp--ell',
  ]);
  return (
    <label className={clsStr}>
        <Grid gutters={noGutters ? '' : 'l'} align={align ? align : 'flex-start'} noWrap={noWrap}>
          <GridItem behavior="fixed" className={`${mainCls}__grid-input`}>
            <input className={clsInput} type="radio" name={name} onChange={handleChange} checked={checked} disabled={disabled} value={value}/>
            <div className={clsCtrStr}>
              <div className={`c-bg--${color}`}/>
            </div>
          </GridItem>
          { !!labelRes && <GridItem className={labelCLs}>{labelRes}</GridItem> }
        </Grid>
    </label>
  );
};

RadioField.propTypes = {
  /**
   * Component class
   */
  className: PropTypes.string,

  radioClassName: PropTypes.string,

  /**
   * Input name
   */
  name: PropTypes.string,

  /**
   * Radio color
   */
  color: PropTypes.string,

  /**
   * Radio value
   */
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),

  /**
   * Radio label
   */
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),

  /**
   * Callback when the input is changed
   */
  onChange: PropTypes.func,

  /**
   * Initial checked state
   */
  checked: PropTypes.bool,

  /**
   * Disabled state
   */
  disabled: PropTypes.bool,

  /**
   * Disabled state
   */
  required: PropTypes.bool,

  align: PropTypes.string,
  noGutters: PropTypes.bool,
  noWrap: PropTypes.bool,
};

RadioField.defaultProps = {
  className: '',
  radioClassName: '',
  color: 'primary',
  value: 0,
  label: '',
  name: null,
  checked: false,
  disabled: false,
  required: false,
  align: null,
  noGutters: false,
  onChange: () => {},
  noWrap: false,
};
